module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cluster-detail"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('div', {
    staticClass: "view-title-container"
  }, [_c('div', {
    staticClass: "title-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.detail.info.name))]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    class: _vm.detail.info.agent ? (_vm.detail.info.agent.status === 1 ? 'available' : 'unavailable') : 'unavailable'
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.detail.info.agent ? (_vm.detail.info.agent.status === 1 ? _vm.attrText.available : _vm.attrText.unavailable) : _vm.attrText.unavailable) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "del-btn"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.onShowConfigFile()
      }
    }
  }, [_c('translate', [_vm._v("Configuration File")])], 1), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onShowChangeName()
      }
    }
  }, [_c('translate', [_vm._v("Set Cluster")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteCluster()
      }
    }
  }, [_c('translate', [_vm._v("Delete Cluster")])], 1) : _vm._e(), _vm._v(" "), (_vm.detail.info.parent_id) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.returnCluster()
      }
    }
  }, [_c('translate', [_vm._v("Return The Cluster")])], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ssk-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "active-name": _vm.detail.currentTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [(_vm.$route.query.type !== 'settings') ? _c('div', {
    staticClass: "add-ssk"
  }, [(_vm.detail.currentTab === 'ecs') ? _c('span', [_c('translate', [_vm._v("Set The Security Mode:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#58d99f"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.cluster.detail.info.safe_mode ? _vm.attrText.on : _vm.attrText.off))])], 1) : _vm._e(), _vm._v(" "), (_vm.detail.currentTab === 'ecs') ? _c('el-button', {
    staticClass: "change-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterSafeMode()
      }
    }
  }, [_c('translate', [_vm._v("Change")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Add")])], 1) : _vm._e(), _vm._v(" "), (_vm.detail.currentTab === 'ecs' && !_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterScanImport()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Scan Import")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterBatchInstance()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Mass import")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.scanDis
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowClusterAkImport()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Cloud Account Import")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.tableHeader.deleteIds === '' || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.batchDel(null, _vm.tableHeader.deleteIds)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    }
  }, [(_vm.detail.currentTab === 'ecs') ? _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "Operating System"
    },
    model: {
      value: (_vm.tableHeader.searchForm.type),
      callback: function($$v) {
        _vm.tableHeader.searchForm.type = $$v
      },
      expression: "tableHeader.searchForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.os,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Linux",
      "value": "%linux%"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Windows",
      "value": "%win32%"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detail.currentTab === 'rds') ? _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "Type"
    },
    model: {
      value: (_vm.tableHeader.searchForm.type),
      callback: function($$v) {
        _vm.tableHeader.searchForm.type = $$v
      },
      expression: "tableHeader.searchForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.type,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "MySQL",
      "value": "mysql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SQL Server",
      "value": "mssql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "PostgreSQL",
      "value": "postgresql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Oracle",
      "value": "oracle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-select', {
    staticClass: "account-search",
    attrs: {
      "placeholder": "userType"
    },
    on: {
      "change": _vm.initSelect
    },
    model: {
      value: (_vm.tableHeader.searchForm.condition),
      callback: function($$v) {
        _vm.tableHeader.searchForm.condition = $$v
      },
      expression: "tableHeader.searchForm.condition"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.select,
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.name,
      "value": "q_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IP",
      "value": "q_ip"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "icon": "search",
      "on-icon-click": _vm.onSearch,
      "disabled": _vm.tableHeader.searchForm.condition == ''
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch()
      }
    },
    model: {
      value: (_vm.tableHeader.searchForm.text),
      callback: function($$v) {
        _vm.tableHeader.searchForm.text = $$v
      },
      expression: "tableHeader.searchForm.text"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.servers,
      "name": "ecs"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.dataBase,
      "name": "rds"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.setting,
      "name": "settings"
    }
  }, [(_vm.detail.info.agent && !_vm.detail.info.parent_id) ? _c('div', {
    staticClass: "setting-wrapper"
  }, [(_vm.onlineConnectTooltip) ? _c('div', [_c('translate', {
    staticClass: "font-danger",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The agent has alive users,please disconnect them to continue. ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.agentUpdate) ? _c('div', [_c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" Please perform the following script on the control node to update the control node to the latest version ")]), _vm._v(" "), _c('div', {
    ref: "text",
    staticClass: "copy-text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.setting.available.code) + "\n\t\t\t\t\t\t\t\t"), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.setting.available.code),
      expression: "setting.available.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detail.agentUpdate && !_vm.detail.backAgent) ? _c('translate', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The network has successfully installed the agent. If you need to change, please click \"Uninstall Agent\". ")]) : _vm._e(), _vm._v(" "), (_vm.detail.backAgent) ? _c('div', [_c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" Please perform the following script on the control node to roll back the management node ")]), _vm._v(" "), _c('div', {
    ref: "text",
    staticClass: "copy-text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.setting.backAgentCode) + "\n\t\t\t\t\t\t\t\t"), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.setting.backAgentCode),
      expression: "setting.backAgentCode",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "general"
  }, [_c('translate', {
    staticClass: "m-space bold"
  }, [_vm._v("General Situation")]), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node IP:")]), _vm._v(" " + _vm._s(_vm.detail.info.agent.host))], 1), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node version:")]), _vm._v(" " + _vm._s(_vm.detail.info.agent ? _vm.detail.info.agent.version : ''))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "agent-wrapper"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.updateAgent()
      }
    }
  }, [_c('translate', [_vm._v("Agent Update")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.backAgent()
      }
    }
  }, [_c('translate', [_vm._v("Back Agent")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.unBindAgent()
      }
    }
  }, [_c('translate', [_vm._v("Uninstall Agent")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.detail.info.agent && !_vm.detail.info.parent_id) ? _c('div', {
    staticClass: "setting-unavailable"
  }, [(_vm.setting.unavailable.code !== '') ? _c('div', {
    staticClass: "setting-wrapper"
  }, [_c('p', [_c('translate', [_vm._v(" Please execute the following script on a server in the current cluster (recommended using CentOS 7.9, 64 Bit) to configure the machine as a managed node.")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "copy-text"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('p', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.setting.unavailable.code))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.setting.unavailable.code),
      expression: "setting.unavailable.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "type": "text"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('p', [_c('translate', [_vm._v("Notes for Attention:")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 1) Network recommends configuration 2 cores 4G,40GB disk,10Mbps network bandwidth.(Recommended configuration:4 cores,4G,40GB disk,20Mbps or higher network bandwidth)")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 2) To ensure the normal operation of the control node functions, the remaining disk space must be greater than 5GB.")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 3) After executing the installation script, CloudLinker will use the public IP of your host as the control node IP. If there are any special requirements, please replace \"default\" with the IP or domain name you want to specify. If you need to modify the connection port of the control node, replace the default port number with the new one.")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v(" 4) In consideration of the system performance, it is recommended that the server of agent don’t be used for other purposes. ")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("5) Make sure that wget and curl are installed on your server.")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("6) Other:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mrdoc.cloudcare.cn/doc/278/",
      "target": "_blank"
    }
  }, [_c('translate', [_vm._v("Control Node Function Description Document")])], 1)], 1)]), _vm._v(" "), _c('p', {
    staticClass: "general"
  }, [_c('translate', {
    staticClass: "m-space bold"
  }, [_vm._v("General Situation")]), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node IP:")]), _vm._v(" "), _c('translate', [_vm._v("No time")])], 1), _vm._v(" "), _c('span', {
    staticClass: "m-space"
  }, [_c('translate', {
    staticClass: "m-space"
  }, [_vm._v("Control node version:")]), _vm._v(" "), _c('translate', [_vm._v("No time")])], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    staticClass: "setting-tab",
    attrs: {
      "active-name": _vm.setting.settingActivetab
    },
    on: {
      "tab-click": _vm.onSettingTabClick
    },
    model: {
      value: (_vm.setting.activeTab),
      callback: function($$v) {
        _vm.setting.activeTab = $$v
      },
      expression: "setting.activeTab"
    }
  }, [(!_vm.detail.info.parent_id) ? _c('div', {
    staticClass: "setting-header"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSettingAdd($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Add")])], 1), _vm._v(" "), (_vm.setting.activeTab === 'logFilter') ? _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": this.setting.logBatchIds === ''
    },
    on: {
      "click": function($event) {
        _vm.batchDelLogFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.shareCluster,
      "name": "shareCluster"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.setting.shareList,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.teamId
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.company.domain) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.teamName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.company.full_name) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.shareTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delShareCluster(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Cancel Share")])], 1)]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.logFilter,
      "name": "logFilter"
    }
  }, [(_vm.detail.info && _vm.setting.settingActivetab === 'logFilter') ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.setting.logList,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectLog
    }
  }, [(!_vm.detail.info.parent_id) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.filtersOperation
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.operator) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.condition
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.condition) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delLogFilter(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Delete")])], 1)]
      }
    }])
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.detail.info && _vm.$route.query.type !== 'settings') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "table-wrapper"
  }, [(_vm.detail.list && _vm.detail.currentTab !== 'settings') ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.list,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.onSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.name,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.name
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.name))])]), _vm._v(" "), (scope.row.resource_status === 2) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.attrText.needPsw,
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning text-warning"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.login_type), function(item) {
          return _c('p', [_c('span', [_vm._v(_vm._s(item.username))]), _vm._v(" "), (item.csos_check === 'open') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": _vm.attrText.cos,
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "fa fa-expeditedssl"
          })]) : _vm._e(), _vm._v(" "), (item.autologin) ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.type == 'WinServer' ? _vm.attrText.passwordFree : _vm.attrText.targetKey,
              "placement": "top"
            }
          }, [_c('i', {
            staticClass: "fa fa-unlock-alt"
          })]) : _vm._e()], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.detail.currentTab === 'ecs' ? 'IP' : _vm.attrText.dataBaseName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.detail.currentTab === 'ecs') ? _c('p', [_vm._v(_vm._s(scope.row.ip))]) : _c('div', _vm._l((scope.row.db_name), function(item) {
          return _c('p', [_vm._v(_vm._s(item))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.detail.currentTab === 'ecs' ? _vm.attrText.os : _vm.attrText.innerIp,
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.detail.currentTab === 'ecs') ? _c('div', [_vm._v(_vm._s(scope.row.type === 'WinServer' ? 'Windows' : 'Linux'))]) : _c('div', [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": scope.row.ip
          }
        }, [_c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.ip))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.detail.currentTab === 'ecs' ? _vm.attrText.specification : _vm.attrText.type
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.detail.currentTab === 'ecs') ? _c('span', [_vm._v(_vm._s(scope.row.flavor ? scope.row.flavor : '-'))]) : _c('div', [(scope.row.type === 'SQLServerDatabase') ? _c('span', [_vm._v("SQL Server")]) : (scope.row.type === 'PostgreSQLDatabase') ? _c('span', [_vm._v("PostgreSQL")]) : (scope.row.type === 'OracleDatabase') ? _c('span', [_vm._v("Oracle")]) : _c('span', [_vm._v("MySQL")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.Connectivity
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.test_result === 'pending' || (_vm.detail.info.agent ? _vm.detail.info.agent.status !== 1 : !_vm.detail.info.agent)
          },
          on: {
            "click": function($event) {
              _vm.onTestConnection(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Test")])], 1), _vm._v(" "), (scope.row.test_result === 'pending') ? _c('i', {
          staticClass: "el-icon-loading"
        }) : _vm._e(), _vm._v(" "), (scope.row.test_result === 'disable' || scope.row.test_result === 'enable') ? _c('span', {
          staticClass: "badge",
          class: scope.row.test_result && scope.row.test_result === 'disable' ? 'unavailable' : 'available'
        }, [_vm._v(_vm._s(scope.row.test_result && scope.row.test_result === 'disable' ? _vm.attrText.no : _vm.attrText.yes))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.onSetting(scope.row.id)
            }
          }
        }, [_c('translate', [_vm._v("Setting")])], 1), _vm._v(" "), (!_vm.detail.info.parent_id) ? _c('el-button', {
          attrs: {
            "type": "text",
            "loading": scope.row.deleting
          },
          on: {
            "click": function($event) {
              _vm.batchDel(scope.row, [scope.row.id])
            }
          }
        }, [(!scope.row.deleting) ? _c('translate', [_vm._v("Delete")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.detail.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.detail.totalPage,
      "current-page": _vm.detail.currentPage,
      "page-size": 10
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.attrText.upload,
      "visible": _vm.upload.isUpload
    },
    on: {
      "update:visible": function($event) {
        _vm.upload.isUpload = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password
    }
  }, [_vm._v(":\n\t\t\t\t\t\t"), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.upload.password),
      callback: function($$v) {
        _vm.upload.password = $$v
      },
      expression: "upload.password"
    }
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("(The password of %{upload.username} for the destination host)")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.upload.password === ''
    },
    on: {
      "click": function($event) {
        _vm.onComfirmUpload()
      }
    }
  }, [(_vm.upload.status !== 'pending') ? _c('span', [_c('translate', [_vm._v("Upload")])], 1) : _vm._e(), _vm._v(" "), (_vm.upload.status === 'pending') ? _c('span', [_c('translate', [_vm._v("Uploading")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.upload.isUpload = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.turnInstance,
      "visible": _vm.cluodDialog.start,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.cluodDialog.start = $event
      }
    }
  }, [_c('translate', [_vm._v("Are you sure to Turn On Instance?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onStart
    }
  }, [_c('translate', [_vm._v("Ok")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cluodDialog.start = false
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "instance-dialog",
    attrs: {
      "title": _vm.attrText.reStartText,
      "visible": _vm.cluodDialog.reStart
    },
    on: {
      "update:visible": function($event) {
        _vm.cluodDialog.reStart = $event
      },
      "open": _vm.onOpenRestart,
      "click": function($event) {
        $event.stopPropagation();
        _vm.testOpen()
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Are you sure to start 1 instances?")]), _vm._v(" "), _c('p', {
    staticClass: "instance-id"
  }, [_vm._v(_vm._s(_vm.cluodDialog.Instances.InstanceId))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('translate', [_vm._v("The Way Of Start:")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.cluodDialog.reStartWay),
      callback: function($$v) {
        _vm.cluodDialog.reStartWay = $$v
      },
      expression: "cluodDialog.reStartWay"
    }
  }, [_c('translate', [_vm._v("Reboot")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.cluodDialog.reStartWay),
      callback: function($$v) {
        _vm.cluodDialog.reStartWay = $$v
      },
      expression: "cluodDialog.reStartWay"
    }
  }, [_c('translate', [_vm._v("Forced Restart")])], 1)], 1)], 1), _vm._v(" "), (_vm.cluodDialog.reStartWay === '2') ? _c('div', {
    staticClass: "force-stop"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The forced restart server will causes the virtual host to lose data that is not currently saved. ")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.cluodDialog.isForcereStart),
      callback: function($$v) {
        _vm.cluodDialog.isForcereStart = $$v
      },
      expression: "cluodDialog.isForcereStart"
    }
  }, [_c('translate', [_vm._v("Make Sure To Restart")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.cluodDialog.reStartWay === '2' && !_vm.cluodDialog.isForcereStart
    },
    on: {
      "click": _vm.onRestart
    }
  }, [_c('translate', [_vm._v("Ok")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cluodDialog.reStart = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "instance-dialog",
    attrs: {
      "title": _vm.attrText.stopInstanceText,
      "visible": _vm.cluodDialog.stopInstance
    },
    on: {
      "update:visible": function($event) {
        _vm.cluodDialog.stopInstance = $event
      },
      "open": _vm.onOpenStop,
      "click": function($event) {
        $event.stopPropagation();
        _vm.testOpen()
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("Are you sure to stop 1 instances?")]), _vm._v(" "), _c('p', {
    staticClass: "instance-id"
  }, [_vm._v(_vm._s(_vm.cluodDialog.Instances.InstanceId))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('translate', [_vm._v("The Way Of Stop:")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.cluodDialog.stopWay),
      callback: function($$v) {
        _vm.cluodDialog.stopWay = $$v
      },
      expression: "cluodDialog.stopWay"
    }
  }, [_c('translate', [_vm._v("Stop")])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.cluodDialog.stopWay),
      callback: function($$v) {
        _vm.cluodDialog.stopWay = $$v
      },
      expression: "cluodDialog.stopWay"
    }
  }, [_c('translate', [_vm._v("Forced To Stop")])], 1)], 1)], 1), _vm._v(" "), (_vm.cluodDialog.stopWay === '2') ? _c('div', {
    staticClass: "force-stop"
  }, [_c('translate', {
    staticClass: "tip",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v(" The forced stop server will causes the virtual host to lose data that is not currently saved. ")]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.cluodDialog.isForceShop),
      callback: function($$v) {
        _vm.cluodDialog.isForceShop = $$v
      },
      expression: "cluodDialog.isForceShop"
    }
  }, [_c('translate', [_vm._v("Make Sure To Stop")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.cluodDialog.stopWay === '2' && !_vm.cluodDialog.isForceShop
    },
    on: {
      "click": _vm.onStop
    }
  }, [_c('translate', [_vm._v("Ok")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cluodDialog.stopInstance = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "instance-dialog",
    attrs: {
      "title": _vm.attrText.updateTip,
      "visible": _vm.detail.updateTip
    },
    on: {
      "update:visible": function($event) {
        _vm.detail.updateTip = $event
      },
      "close": function($event) {
        _vm.closeUpdateTip()
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("The control node agent has released a new version, please update,")]), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("can click")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mrdoc.cloudcare.cn/doc/318/"
    }
  }, [_c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("update log")])], 1), _vm._v(" "), _c('translate', {
    attrs: {
      "tag": "span"
    }
  }, [_vm._v("for detail.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "agent-compile"
  }, [_c('p', {
    staticClass: "agent-version"
  }, [_c('translate', {
    staticClass: "sub-title"
  }, [_vm._v("Current Version:")]), _vm._v(" "), _c('span', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.detail.info.agent ? _vm.detail.info.agent.version : ''))])], 1), _vm._v(" "), _c('p', {
    staticClass: "agent-version"
  }, [_c('translate', {
    staticClass: "sub-title"
  }, [_vm._v("New Version:")]), _vm._v(" "), _c('span', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.newAgentVersion))])], 1)]), _vm._v(" "), (_vm.detail.info.agent && _vm.detail.info.agent.version && _vm.detail.info.agent.version.split('-')[0].split('.')[0] === '2') ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#fda541",
      "margin-top": "30px"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Version 2.0 upgrade to Version 3.0 will disable the old connection code, please be prepared")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.updateAgent
    }
  }, [_c('translate', [_vm._v("Update Now")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeUpdateTip()
      }
    }
  }, [_c('translate', [_vm._v("Remind Me Later")])], 1)], 1)]), _vm._v(" "), _c(_vm.currentRightPanel, {
    ref: "rightComponent",
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.callback,
      "upload": _vm.onUpload,
      "onShowCloudDialog": _vm.onShowCloudDialog
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3376bf46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/cluster-detail.vue
// module id = 547
// module chunks = 4 5 6